import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaRiverApi = createApi({
    reducerPath: "core/measurement/river",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementRiverList"],
    endpoints: (builder) =>({
        measurementRiverFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementRiverList'],
            query: (query = '') => ({
                url: "core/measurement/river" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementRiverCreate: builder.mutation({
            invalidatesTags: ['measurementRiverList'],
            query: (data)=>({url: "core/measurement/river", method: "POST", data})
        }),
        measurementRiverUpdate: builder.mutation({
            invalidatesTags: ['measurementRiverList'],
            query: (data)=>({url: "/core/measurement/river/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        measurementRiverDelete: builder.mutation({
            invalidatesTags: ['measurementRiverList'],
            query: (id)=>({url: "/core/measurement/river/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementRiverFindAllQuery, useMeasurementRiverCreateMutation, useMeasurementRiverUpdateMutation, useMeasurementRiverDeleteMutation } = meaRiverApi;
export {meaRiverApi};
